import React from 'react';

import { PipeInput } from '../../../containers/PipeInput.container';

import type { FlowInputOutput } from '../../../types/flows.types';

export const FlowInputPage: React.FC<{ flow: FlowInputOutput[] }> = ({ flow }) => {
  const firstPipe = flow?.[0].data;

  return <PipeInput inputPipe={firstPipe} />;
};
